export const ACCESS_TOKEN = 'Authorization'
export const USER_INFO = 'UserInfo'
export const USER_VIP = 'UserVip'
export const LOCATION = 'Location'
export const CITY = 'City'
export const ADD_KEEP_ALIVE = 'ADD_KEEP_ALIVE'
export const REMOVE_KEEP_ALIVE = 'REMOVE_KEEP_ALIVE'
export const CLEAR_KEEP_ALIVE = 'CLEAR_KEEP_ALIVE'
